import { render, staticRenderFns } from "./LatestNewsWidget.vue?vue&type=template&id=2a9d2c14&scoped=true&"
import script from "./LatestNewsWidget.vue?vue&type=script&lang=js&"
export * from "./LatestNewsWidget.vue?vue&type=script&lang=js&"
import style0 from "./LatestNewsWidget.vue?vue&type=style&index=0&id=2a9d2c14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9d2c14",
  null
  
)

export default component.exports